import {
	Button,
	CircularProgress,
	Dialog,
	DialogContent,
	Grid2,
	IconButton,
	InputBase,
	Typography,
} from '@mui/material';
import { CloseIcon, DeleteIcon, UploadIcon } from '../../assets/icons/Icons';
import { FileUploadDiv, helperText } from '../../assets/theme/Theme';
import Dropzone from 'react-dropzone';
import { MAIN_THEME_COLOR } from '../../assets/theme/Colors';
import SmallLimitationAlert from '../../components/SmallLimitationAlert';

interface PopupProps {
	isModalOpen: boolean;
	selectedFile: File | null;
	onClose: () => void;
	onSubmit: () => void;
	readTextFile: (file: File[]) => void;
	isUploading: boolean;
	txtError: { status: boolean; msg: string };
	limitError: { status: boolean; msg: string };
	onHandleAction: () => void;
}

function UploadFilePopup({
	isModalOpen,
	onClose,
	isUploading,
	onSubmit,
	readTextFile,
	selectedFile,
	txtError,
	limitError,
	onHandleAction,
}: PopupProps) {
	return (
		<>
			<Dialog open={isModalOpen} fullWidth maxWidth="md" scroll="body">
				<DialogContent style={{ padding: '0px 0px 20px 0px' }}>
					<Grid2
						container
						sx={{ boxShadow: 3 }}
						padding={'10px'}
						flexDirection={'row'}
						justifyContent={'space-between'}
						alignItems={'center'}>
						<Typography fontWeight={'600'}>Upload Files</Typography>
						<IconButton style={{ padding: '0' }} onClick={onClose}>
							<CloseIcon />
						</IconButton>
					</Grid2>
					<Grid2 container padding={'15px'}>
						<Grid2
							container
							width={'100%'}
							flexDirection={'column'}>
							<Dropzone
								disabled={limitError.status}
								onDrop={acceptedFiles =>
									readTextFile(acceptedFiles)
								}>
								{({ getRootProps, getInputProps }) => (
									<section style={{ width: '100%' }}>
										<div
											{...getRootProps()}
											style={{
												backgroundColor: '#FFFFFF',
												borderRadius: '5px',
												padding: '50px',
												textAlign: 'center',
												marginBottom: '10px',
												border: txtError.status
													? '1px dashed red'
													: '1px dashed #D9D9D9',
											}}>
											<input {...getInputProps()} />
											<UploadIcon />
											<br />
											<Typography
												fontSize={'16px'}
												fontWeight={'700'}
												color={'#7C7C7C'}>
												Select file here...
											</Typography>
										</div>
										<Grid2
											container
											alignItems={'center'}
											flexDirection={'row'}>
											{selectedFile && (
												<Grid2
													container
													bgcolor={'#EEF1F7'}
													borderRadius={'5px'}
													padding={
														'5px 10px 5px 10px'
													}
													sx={{
														boxShadow: 2,
														marginBottom: '5px',
														overflow: 'hidden',
													}}>
													<Typography
														style={{
															wordWrap:
																'break-word',
															wordBreak:
																'break-all',
														}}
														color={'#292D32'}
														fontSize={'14px'}>
														{selectedFile.name}
													</Typography>
												</Grid2>
											)}
										</Grid2>
									</section>
								)}
							</Dropzone>
							<Typography style={helperText}>
								{txtError.msg}
							</Typography>
							{limitError.status && (
								<SmallLimitationAlert
									content={limitError.msg}
									handleActionButtonClick={onHandleAction}
								/>
							)}
						</Grid2>
						<Grid2
							container
							justifyContent={'flex-end'}
							paddingTop={'10px'}
							width={'100%'}
							flexDirection={'row'}>
							<Button
								onClick={onClose}
								sx={{
									paddingLeft: '15px',
									paddingRight: '15px',
									color: '#7F7C7C',
									border: '1px solid #7F7C7C',
									fontWeight: '600',
									textTransform: 'none',
									marginRight: '10px',
								}}>
								{'Cancel'}
							</Button>
							<IconButton
								disableRipple
								onClick={onSubmit}
								sx={{
									backgroundColor: MAIN_THEME_COLOR,
									paddingX: '10px',
									color: '#FFFFFF',
									textTransform: 'none',
									borderRadius: '5px',
									height: '40px',
									alignItems: 'center',
									width: '80px',
									marginRight: '5px',
								}}>
								{isUploading ? (
									<CircularProgress
										sx={{ color: '#FFFFFF' }}
										size={16}
									/>
								) : (
									<Typography
										fontWeight={'600'}
										fontSize={'14px'}
										color={'#FFFFFF'}>
										Upload
									</Typography>
								)}
							</IconButton>
						</Grid2>
					</Grid2>
				</DialogContent>
			</Dialog>
		</>
	);
}

export default UploadFilePopup;
